﻿function updateTabs(setState, type) {
	return (newTabs) => {
		setState((state) => {
			state.splitScreen[type] = [...newTabs];
		});
	};
}

export default (setState) => {
	return {
		updateDockedTabs: updateTabs(setState, 'dockTabs'),
		updateUndockedTabs: updateTabs(setState, 'mainTabs'),
		navigationPanel: {
			updateVisibility: (newState) => {
				setState((state) => {
					state.navigationPanel.isVisible = newState;
				});
			}
		}
	};
};
